import React from "react";
import { Icon } from "../../styled";
import { CheckBoxContainer } from "../../styled/editor";

const CheckBox = ({ checked }) => <CheckBoxContainer {...{ checked }}>{checked && <Icon>check</Icon>}</CheckBoxContainer>;

export default CheckBox;
